import { getLocaleFromLocaleStorage } from 'uwork-app-core';

export const I18N_API_URL = process.env.REACT_APP_I18N_API_URL;
export const I18N_LOCALE_DEFAULT = getLocaleFromLocaleStorage() || 'nb';
export const I18N_LOCALE_FALLBACK = 'en';
